import React, { HTMLAttributes, useMemo } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
// import { Context } from "@xt/xtbase";
//const { useTranslation } = Hooks;
import store from "store";
import styles from "./index.module.scss";
import XtLoading from "../Loading";
import XtToLogin from "../ToLogin";
import XtFontScale from "../FontScale";
import XtNoData, { NoDataProps } from "../NoData";
enum XtPaneThemeClassName {
  simple = "simple",
}

interface Props extends HTMLAttributes<HTMLDivElement>, NoDataProps {
  attr?: any;
  loading: boolean;
  noData?: boolean;
  theme?: XtPaneThemeClassName;
  minHeight?: number;
  isNeedLogin?: boolean;
  overflowType?: StyleProps["overflowY"];
  style?: StyleProps;
}

const XtPane: React.FC<Props> = ({
  className,
  loading = false,
  noData = false,
  theme = "",
  minHeight = 200,
  isNeedLogin = false,
  overflowType = "auto",
  style,
  children,
  ...rest
}) => {
  //const t = useTranslation();
  const { isLogin } = store.user;

  const getTheme = useMemo(() => {
    return `xt-pane-${theme}-container`;
  }, [theme]);

  return (
    <div className={cx(className,styles["xt-pane-container"], styles[getTheme])} style={{ minHeight: minHeight + "px", overflowY: overflowType, ...style }}>
      {isNeedLogin && !isLogin ? (
        <div className="pane-nologin" style={{ minHeight: minHeight + "px" }}>
          <XtFontScale>
            <XtToLogin />
          </XtFontScale>
        </div>
      ) : (
        <>
          {noData && !loading ? (
            <div className="pane-nodata" style={{ minHeight: minHeight + "px" }}>
              <XtFontScale>
                <XtNoData noIcon={rest.noIcon}></XtNoData>
              </XtFontScale>
            </div>
          ) : (
            children
          )}
        </>
      )}
      {loading && <XtLoading />}
    </div>
  );
};
export default observer(XtPane);
